// Onboarding API service for Suspire onboarding flow
import { authenticatedFetch } from '../utils/apiInterceptor';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export async function getOnboardingStage(token) {
  const response = await authenticatedFetch(`${API_BASE}/api/onboarding/stage/`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.json();
}

export async function getOnboardingCategories(token) {
  const response = await authenticatedFetch(`${API_BASE}/api/onboarding/categories/`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.json();
}

export async function autoSaveOnboardingForm(token, autoSaveData) {
  const response = await authenticatedFetch(`${API_BASE}/api/onboarding/form/`, {
    method: 'PATCH',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(autoSaveData),
  });
  const data = await response.json();

  // Flatten nested structure to match form structure
  const flattened = {
    // Brand basic info
    brand_name: data.brand?.name || '',
    brand_logo_url: data.brand?.logo || '',

    // Contact Information
    ...(data.contact_information || {}),

    // Legal & Financial
    ...(data.legal_financial || {}),
    // Map file fields from nested structure
    gstin_certificate: data.legal_financial?.gstin_certificate_file || data.legal_financial?.gstin_certificate || '',
    cancelled_cheque: data.legal_financial?.cancelled_cheque_file || data.legal_financial?.cancelled_cheque || '',

    // Manufacturing
    ...(data.manufacturing || {}),
    manufacturer_excel: data.manufacturing?.manufacturer_excel_file || data.manufacturing?.manufacturer_excel || '',

    // Order Policy
    ...(data.order_policy || {}),
    general_processing_timeline: data.order_policy?.general_processing_timeline || data.order_policy?.general_processing_timeline || '',

    // Exchange Policy
    exchanges: data.exchange_policy ? Object.values(data.exchange_policy).some(v => v === true) : false,
    ...(data.exchange_policy || {}),

    // Return Policy
    returns: data.return_policy ? Object.values(data.return_policy).some(v => v === true) : false,
    ...(data.return_policy || {}),

    // Product Categorization
    ...(data.product_categorization || {}),
    suspire_category: data.product_categorization?.suspire_category?.id || data.product_categorization?.suspire_category || '',
    signed_agreement: data.product_categorization?.signed_agreement_file || data.product_categorization?.signed_agreement || '',
    certifications: data.product_categorization?.certifications || '',

    // Warehouse (take first warehouse if multiple)
    ...(data.warehouses && data.warehouses.length > 0 ? data.warehouses[0] : {}),
  };

  return flattened;
}

export async function uploadOnboardingFile(token, file, file_type) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('file_type', file_type);
  
  // Use authenticatedFetch which now supports FormData and handles token refresh
  const response = await authenticatedFetch(`${API_BASE}/api/core/s3/upload/`, {
    method: 'POST',
    headers: { 
      'Authorization': `Bearer ${token}`
      // Don't set Content-Type - browser will set it automatically with boundary
    },
    body: formData,
  });
  
  return response.json();
}

export async function submitOnboardingForm(token, data) {
  const response = await authenticatedFetch(`${API_BASE}/api/onboarding/submit/`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();
  return result;
}

export async function getSubscriptionStatus(token) {
  const response = await authenticatedFetch(`${API_BASE}/api/onboarding/subscription-status/`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.json();
}

export async function completeSubscription(token) {
  const response = await authenticatedFetch(`${API_BASE}/api/onboarding/complete-subscription/`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.json();
}

export async function getOnboardingFormData(token) {
  const response = await authenticatedFetch(`${API_BASE}/api/onboarding/form/`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.json();
}

export async function updateOnboardingForm(token, data) {
  const response = await authenticatedFetch(`${API_BASE}/api/onboarding/form/`, {
    method: 'PATCH',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();
  return result;
}
